import React from 'react';
import styled from '@emotion/styled';
import type { SpaceProps, WidthProps } from 'styled-system';
import { space, width } from 'styled-system';

import Carousel from 'common/components/Carousel';
import ShowAllLink from 'common/components/Carousel/controls/ShowAllLink';
import { Flex } from 'common/components/Flex';
import type { ContentSliderItemProps } from './ContentSliderItem';
import ContentSliderItem from './ContentSliderItem';

interface ContentSliderProps {
  titleText?: string;
  seeAllText?: string;
  seeAllUrl: string;
  items: ContentSliderItemProps[];
}

const SLIDE_GAP = [16, 24, 24, 32];
const SLIDE_WIDTH = [212, 204, 204, 292];

const SlideContainer = styled.section<WidthProps>`
  ${width};
`;

const ShowAllContainer = styled(Flex)<SpaceProps>`
  ${space};
`;

const ContentSlider = ({ titleText, seeAllText, seeAllUrl, items }: ContentSliderProps) => {
  if (!items || !items.length) {
    return null;
  }

  return (
    <section data-corgi-id="content-slider">
      <Carousel slideGap={SLIDE_GAP} title={titleText} withTopControls>
        {items.map((item, index) => (
          <SlideContainer key={index} width={SLIDE_WIDTH}>
            <ContentSliderItem key={index} {...item} />
          </SlideContainer>
        ))}
      </Carousel>
      {seeAllUrl && seeAllText && (
        <ShowAllContainer pt="sp_24" flexDirection="row-reverse">
          <ShowAllLink text={seeAllText} url={seeAllUrl} />
        </ShowAllContainer>
      )}
    </section>
  );
};

export default ContentSlider;
